import { render, staticRenderFns } from "./orderAndpicklist.vue?vue&type=template&id=1d064d0b&"
import script from "./orderAndpicklist.vue?vue&type=script&lang=js&"
export * from "./orderAndpicklist.vue?vue&type=script&lang=js&"
import style0 from "./orderAndpicklist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports